module.exports = __webpack_public_path__ + "static/img/home_1.f4619b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/home_1.png
// module id = POmk
// module chunks = 4